module.exports = __webpack_public_path__ + "img/404.bdd8ee26.png";